// @flow

import React from 'react';
import { Col, Grid, Image, Glyphicon, Row, Alert, SplitButton,
  MenuItem,
  ButtonToolbar } from 'react-bootstrap';
import Form from './Form/';
import currencySymbols from '../../../utils/currencySymbols';
import './styles.css';
import discountApplied from './discount_applied.png';
import _ from "lodash";

export default props => {
  const initialValues = {
    acceptRules: props.basketData.acceptRules,
    acceptTerms: props.basketData.acceptTerms
  };
  const handleClickCurrency = currency => {
    props.changeBasketCurrency(props.id, currency);
  };


  const renderAvailableCurrencies = () => {
    return <ButtonToolbar>
    <SplitButton
  bsStyle="success"
  className="e-round-corner"
  title={props.options.currency}>
   { _.map(props.options.availableCurrencies, currency => {
      if (currencySymbols[currency] !== undefined) {
        const background =
          currency === props.options.currency[0] ? "#d1d3d6" : "";
        return (
          <MenuItem
            onClick={() => handleClickCurrency(currency)}
            key={currency}
            style={{ background }}
          >
            <strong>{currencySymbols[currency]}</strong>
          </MenuItem>
        );
      }
    })}
</SplitButton>
</ButtonToolbar>
  };

  return (
    <Grid>
      <Col className="info">
        <p>
          <Glyphicon glyph="info-sign" style={{ marginRight: '5px' }} />Confirmaton of pick up time is sent to you by
          email and SMS by 17:00 (CET) the day prior to each journey
        </p>
        <p>
          Please ensure you have read and understand our Terms &amp; Conditions, which contain more detailed information,
          including about Luggage Allowance, Child Seats, waiting times in case of flights landing earlier or later than
          scheduled and the general Conditions of Carriage. If you have any questions, please don’t hesitate to ask us.
        </p>
        <p>
          Please make sure you check your junk folder for emails and add us to your safe senders list
        </p>
      </Col>
      <Row className="container enquireText">
        <Col>
          {props.enquireText.show ? (
            <Alert bsStyle="success">
              <h4>{props.enquireText.message.title ? props.enquireText.message.title : null}</h4>
              <p
                dangerouslySetInnerHTML={{
                  __html: props.enquireText.message.content
                }}
              />
            </Alert>
          ) : null}
        </Col>
      </Row>
      <Form
        id={props.id}
        confirmBooking={props.confirmBooking}
        proceedStep={props.proceedStep}
        initialValues={initialValues}
      />
      <Col className='confiremed-price'>
        <Col>
          <h2>Your Total: </h2>
        </Col>
        <Col >
          <div>
            <h2>
              {currencySymbols[props.money.currency[0]]}
              {props.basketData.showCost ? (props.money.totalToPay / 100).toFixed(2) : 'TBC'}
            </h2>
            {currencySymbols[props.money.currency[0]]}
            {props.basketData.showCost ? (props.toPayPerPerson / 100).toFixed(2) : 'TBC'} per person

          </div>
        </Col>
        <Col>{props.pointsApplied && <Image src={discountApplied} /> }         <div className="currencies text-right">
                {renderAvailableCurrencies()}
                </div></Col>

      </Col>

    </Grid>
  );
};



// WEBPACK FOOTER //
// ./src/containers/ConfirmPage/Terms/index.js